import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { UserInformation } from "./views/UserInformation";
import { DebouncedSearch } from "./views/DebouncedSearch";
import { VideoThumbnails } from "./VideoThumbnails";
import billions from './preloaded/billios_videos.json'
import { GenericSeo } from "./views/shared/GenericSeo";

export const Search = () => {

  const { t } = useTranslation();
  const { id } = useParams();

  return (
    <>
      <VideoThumbnails videos={billions} />
      <h1 className="text-2xl font-bold mb-4">{t("search_profile")}</h1>
      <p className="mb-4" dangerouslySetInnerHTML={{ __html: t("search_info") }}></p>
      <DebouncedSearch />
      {id ? <UserInformation /> : <GenericSeo routeName={'search'} />}
    </>
  );
};
